import React, { useEffect, useMemo } from 'react'
import _ from 'lodash'

import {
  Tabs,
  TranslatesModal,
  ConfirmModal,
} from  '../../../components'
import Variation from './variation'
import VariationDetails from './variationDetails'

import actions from './variationActions'

import { updateServings, usePrevious } from './utils'
import CopyVariationModal from './copyVariationModal'

import S from './styled'

const Variations = ({
  locales, model, ingredients, defaultVariation, defaultLocale, servings, browning, cooking, appliances,
  units,
  locked,
}) => {
  const { values, isValidPath, batchChange } = model

  const tabs = useMemo(() => values.map((variation, index) => ({
    value: `${index}`,
    label: _.get(variation, `translates.${defaultLocale}.variant`, 'Main Course'),
    error: !isValidPath(`values[${index}]`),
  })), [defaultLocale, isValidPath, values])

  const prevServings = usePrevious({ servings })

  useEffect(() => {
    if (prevServings && prevServings.servings !== servings) {
      updateServings(servings, prevServings.servings, values, batchChange, units)
    }
  }, [batchChange, servings, values, prevServings, units])

  const {
    currentTab,
    handleTabChange,
    handleAdd,
    handleEdit,
    addNew,
    edit,
    setAddNew,
    setEdit,
    handleCreate,
    handleRename,
    handleDelete,
    itemToDelete,
    setShowDeleteModal,
    onDelete,
    setCurrentTab,
  } = actions({ tabs, model, defaultVariation })

  useEffect(() => {
    if (parseInt(currentTab, 10) >= tabs.length) {
      setCurrentTab(`${tabs.length - 1}`)
    }
  }, [currentTab, setCurrentTab, tabs.length, values.length])

  return (
    <S.Variations>
      <Tabs
        selected={currentTab}
        tabs={tabs}
        onChange={handleTabChange}
        onAdd={locked ? null : handleAdd}
        onEdit={locked ? null : handleEdit}
        onDelete={locked ? null : handleDelete}
      >
        { tabs && tabs.length > 0 && (
          <React.Fragment>
            <Variation {...{ locales, model, ingredients, defaultLocale, browning, cooking, appliances, locked }}
              field={currentTab}
              key={_.get(model, `values[${currentTab}].id`, currentTab)}
            />
            <VariationDetails {...{
              locales, defaultLocale, ingredients, servings, appliances, model,
              field: currentTab, locked,
            }} key={`VariationDetails_${currentTab}`}/>
          </React.Fragment>
        )}
      </Tabs>
      {
        edit && (
          <TranslatesModal
            translates={addNew ?  {} : _.get(values, `[${currentTab}].translates`, {})}
            field=".variant"
            locales={locales}
            defaultLocale={defaultLocale}
            onClose={() => (addNew ? setAddNew : setEdit)(false)}
            onChange={addNew ? handleCreate : handleRename}
          />
        )
      }
      {
        addNew && (
          <CopyVariationModal
            variations={values}
            locales={locales}
            onChange={handleCreate}
            onClose={() => setAddNew(false)}
            defaultLocale={defaultLocale}
            field="variant"
          />
        )
      }
      {
        !!itemToDelete && (
          <ConfirmModal
            isOpened
            onClose={() => setShowDeleteModal(null)}
            onConfirm={onDelete}
            redConfirm
          >
              Are you sure you want to delete this variant?
          </ConfirmModal>
        )
      }
    </S.Variations>
  )
}

export default Variations
